module.exports = __webpack_public_path__ + "static/media/problema-area.91edfbe0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/problema-area.svg
// module id = 2782
// module chunks = 0